/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface BusinessObjectDataStatus { 
    /**
     * The Business Object Format Version for a previously registered Business Object Format
     */
    businessObjectFormatVersion?: number;
    /**
     * The partition value that the Business Object Data is associated with
     */
    partitionValue: string;
    /**
     * A list of Sub-Partition values associated with a Business Object Data
     */
    subPartitionValues?: Array<string>;
    /**
     * The numeric version of a Business Object Data
     */
    businessObjectDataVersion?: number;
    /**
     * A reason for the Business Object Data not being available (NOT_REGISTERED, INVALID, etc...)
     */
    reason?: string;
}
